class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", function (evt) {
      evt.preventDefault();

      if (this.classList.contains("drawers-close-active")) {
        closeActiveDrawers(this.getAttribute("data-drawer"));
      }

      if (this.classList.contains("drawers-close-mega")) {
        closeActiveMegaMenuDrawers(this.getAttribute("data-drawer"));
      }

      //get drawer element by ID from click event target data attribute
      const drawer = document.getElementById(this.getAttribute("data-drawer"));
      //dispatch event to trigger drawer state
      if (drawer) {
        drawer.dispatchEvent(new Event("drawer-toggle"));

        if (
          this.getAttribute("data-drawer-first-child") &&
          drawer.classList.contains("active")
        ) {
          //if it has a child drawer and it is opening this drawer
          //this is used to open the first mega menu

          const childDrawer = document.getElementById(
            this.getAttribute("data-drawer-first-child")
          );
          if (childDrawer) {
            childDrawer.dispatchEvent(new Event("drawer-toggle"));
          }
        }
      }
    });

    function closeActiveDrawers(thisDrawer) {
      //close search bar
      if (
        document
          .querySelector(".header")
          .classList.contains("header--search-active")
      ) {
        document
          .querySelector(".header")
          .classList.remove("header--search-active");
      }

      const activeDrawers = document.querySelectorAll("side-drawer.active");
      if (!activeDrawers) return;

      activeDrawers.forEach((el) => {
        //Toggle drawer event
        if (el.getAttribute("id") != thisDrawer) {
          el.dispatchEvent(new Event("drawer-toggle"));
        }
      });
    }

    function closeActiveMegaMenuDrawers(thisDrawer) {
      const activeDrawers = document.querySelectorAll(
        "side-drawer.drawer--mega.active"
      );
      if (!activeDrawers) return;

      activeDrawers.forEach((el) => {
        //Toggle drawer event
        if (el.getAttribute("id") != thisDrawer) {
          el.dispatchEvent(new Event("drawer-toggle"));
        }
      });
    }
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);
